import React from 'react';
import { makeStyles } from 'tss-react/mui';

import heroNextDefault from 'ha/img-src/landing/hero-next.svg';
import heroNext320Png from 'ha/img-src/landing/hero-next-320.png';
import heroNext768Png from 'ha/img-src/landing/hero-next-768.png';
import heroNext992Png from 'ha/img-src/landing/hero-next-992.png';
import heroNext320Webp from 'ha/img-src/landing/hero-next-320.webp';
import heroNext768Webp from 'ha/img-src/landing/hero-next-768.webp';
import heroNext992Webp from 'ha/img-src/landing/hero-next-992.webp';
import heroNext1687Webp from 'ha/img-src/landing/hero-next-1687.webp';
import heroNext2295Webp from 'ha/img-src/landing/hero-next-2295.webp';

const useStyles = makeStyles()({
  picture: {
    position: 'absolute',
    bottom: 0,
  },
  image: {
    height: '100%',
    objectFit: 'cover',
    width: '100%',
  },
});

export const Picture: React.FC = () => {
  const { classes } = useStyles();
  return (
    <picture className={classes.picture}>
      <source
        type="image/webp"
        media="(max-width: 1148px)"
        sizes="100vw"
        srcSet={`
      ${heroNext320Webp} 320w,
      ${heroNext768Webp} 768w,
      ${heroNext992Webp} 992w,
      ${heroNext1687Webp} 1687w,
      ${heroNext2295Webp} 2295w
      `}
      />
      <source
        media="(max-width: 496px)"
        sizes="100vw"
        srcSet={`
      ${heroNext320Png} 320w,
      ${heroNext768Png} 768w,
      ${heroNext992Png} 992w,
      `}
      />
      <img
        src={heroNextDefault}
        role="presentation"
        className={classes.image}
      />
    </picture>
  );
};
